var jigsaw = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/jigsaw.jpg'
var trellis = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/trellis.jpg'
var trellisDetail1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/trellisDetail1.jpg'
var trellisDetail2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/trellisDetail2.jpg'
var magnet = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/magnet.jpg'
var timeBeing = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-sbu/timebeing.jpg'
var knot =  'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paint-int/knot.jpg'

export const allImagesDesktopOrderHoldingOn = [
  [/*COLUMN 1*/
      [
          {
              name: magnet,
              artistName: "Lorraine Shemesh",
              title: "Magnet",
              year: "2021",
              dimensions: "65 x 50 in., o/c",
              link: "ho1",
              privateCollection: "Permanent Collection of the Hood Museum of Art"
          },
      ],
      [
          {
              name: knot,
              artistName: "Lorraine Shemesh",
              title: "Knot",
              year: "2021",
              dimensions: "48 x 46 5/8 in., o/c",
              link: "ho14",
              privateCollection: ""
          }
      ]
  ],
  [/*COLUMN 2*/
      [
          {
              name: jigsaw,
              artistName: "Lorraine Shemesh",
              title: "Jigsaw",
              year: "2014",
              dimensions: "60 x 51 in., o/c",
              link: "ho5",
              privateCollection: "Private Collection"
          }
      ],
      [
          {
              name: timeBeing,
              artistName: "Lorraine Shemesh",
              title: "Time Being",
              year: "2022",
              dimensions: "49 x 48 1/2 in., o/c",
              link: "ho6",
              privateCollection: ""
          }
      ]
  ],
  [/*COLUMN 3*/
      [
          {
              name: trellis,
              artistName: "Lorraine Shemesh",
              title: "Trellis",
              year: "2020",
              dimensions: "62 1⁄4 x 60 in., o/c",
              link: "ho7",
              privateCollection: ""
          },
          {
              name: trellisDetail1,
              artistName: "Lorraine Shemesh",
              title: "Trellis - detail",
              year: "2020",
              dimensions: "62 1⁄4 x 60 in., o/c",
              link: "ho8",
              privateCollection: ""
          },
          {
              name: trellisDetail2,
              artistName: "Lorraine Shemesh",
              title: "Trellis - detail",
              year: "2020",
              dimensions: "62 1⁄4 x 60 in., o/c",
              link: "ho9",
              privateCollection: ""
          }
      ]
  ]          
]

export const allImagesMobileOrderHoldingOn = [
  [
         {
              name: magnet,
              artistName: "Lorraine Shemesh",
              title: "Magnet",
              year: "2021",
              dimensions: "65 x 50 in., o/c",
              link: "ho1",
              privateCollection: "Permanent Collection of the Hood Museum of Art"
          },
          {
              name: knot,
              artistName: "Lorraine Shemesh",
              title: "Knot",
              year: "2021",
              dimensions: "48 x 46 5/8 in., o/c",
              link: "ho14",
              privateCollection: ""
          },
          {
              name: jigsaw,
              artistName: "Lorraine Shemesh",
              title: "Jigsaw",
              year: "2014",
              dimensions: "60 x 51 in., o/c",
              link: "ho5",
              privateCollection: "Private Collection"
          },
          {
              name: timeBeing,
              artistName: "Lorraine Shemesh",
              title: "Time Being",
              year: "2022",
              dimensions: "49 x 48 1/2 in., o/c",
              link: "ho6",
              privateCollection: ""
          },
          {
              name: trellis,
              artistName: "Lorraine Shemesh",
              title: "Trellis",
              year: "2020",
              dimensions: "62 1⁄4 x 60 in., o/c",
              link: "ho7",
              privateCollection: ""
          },
          {
              name: trellisDetail1,
              artistName: "Lorraine Shemesh",
              title: "Trellis - detail",
              year: "2020",
              dimensions: "62 1⁄4 x 60 in., o/c",
              link: "ho8",
              privateCollection: ""
          },
          {
              name: trellisDetail2,
              artistName: "Lorraine Shemesh",
              title: "Trellis - detail",
              year: "2020",
              dimensions: "62 1⁄4 x 60 in., o/c",
              link: "ho9",
              privateCollection: ""
          }
  ]          
]